module.exports = __webpack_public_path__ + "img/9.39bb6edf.png";